export default function SimpleModal({children, openModal, closeModal}) {

  return (
    <>
      {openModal && (<>
        <div id="simple-modal" className="modal-wrapper">
          <div className="modal bg-white p-4 rounded-lg relative">
            <button
              type="button"
              className="closeModal"
              onClick={()=>{ closeModal(); }}
            >
              <span className="sr-only">Close Modal</span>
              <CloseIcon />
            </button>
            <div className="">
              <div className="">
                  {children}
              </div>
            </div>
          </div>
        </div>
      </>)}
    </>
  );
}

function CloseIcon() {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 17L17 1M1 1L17 17"
        stroke="#5A66AD"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
